'use strict';

import {Injectable, Inject} from 'ng-metadata/core';
import {SearchStateService} from '../../searchState.service';
import {SearchFieldsService} from '../../search.fields.service';
import {getVid} from '../../../appConfig/appConfigForward';
import {STATE_NAMES} from '../../../primoExplore/primoExploreStates.module';
import {JournalsService} from "../../../journals/journals.service";
import {DatabasesService} from "../../../journals/databases.service";
import { AuthoritySearchService } from '../../authority/authoritySearch.service';

interface IPayLoad {
    adaptor?: string;
    search_scope?:string;
    docid: string;
    context: string;
    vid: string;
    pnx: Object;

}

interface IPayLoadMulti {
    vid: string;
    lang?: string;
    records:[{
        docid: string;
        context: string;
        pnx: Object;
    }];
}

@Injectable()
export class PermalinkService {
    private PERMALINK_API_URL: string;
    private vid = getVid();
    private _permalink:string;
    private _shortPermalink:string;
    

    constructor(private searchStateService: SearchStateService,
                private searchFieldsService: SearchFieldsService,
                @Inject('$http') private $http: ng.IHttpService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('restBaseURLs') restBaseURLs,
                @Inject('$state') private $state: ng.ui.IStateService,
                private journalsService: JournalsService,
                private authoritySearchService: AuthoritySearchService,
                private databasesService: DatabasesService){
        this.PERMALINK_API_URL= restBaseURLs.actionsBaseURL+ '/permalink';
    }

    get permalink() {
        return this._permalink;
    }

    set permalink(permalink) {
        this._permalink = permalink;
    }

    get shortPermalink() {
        return this._shortPermalink;
    }

    set shortPermalink(shortPermalink) {
        this._shortPermalink = shortPermalink;
    }

    public buildPayload(item, selectedIds) {
        let payload: IPayLoad = {
                'docid': this.getRecordId(item.pnx.control),
                'context': item.context,
                'vid': this.vid,
                'pnx': item.pnx,
                'lang':this.$translate.use()
        };
        
        if (selectedIds && selectedIds.length>0) {
            payload.id = selectedIds[0];
        }
        payload = this.addEntryIfDefined(payload,'adaptor',item.adaptor);
        //payload = this.addEntryIfDefined(payload,"tab",this.searchFieldsService.tab);

        if ((this.$state.current.name === STATE_NAMES.SEARCH
                || this.$state.current.name === STATE_NAMES.JOURNAL_SEARCH
                || this.$state.current.name === STATE_NAMES.AUTHORITY_SEARCH
                || this.$state.current.name === 'exploreMain.chapters')
                && item.context !== 'WorldCat') {
            let searchScope = this.searchStateService.getSearchObject().scope;
            payload.search_scope = searchScope;
            payload = this.addEntryIfDefined(payload,'tab',this.searchFieldsService.tab);
        } else if ((this.$state.current.name === 'fulldisplay' || this.$state.current.name === STATE_NAMES.JOURNAL_FULL_DISPLAY || this.$state.current.name === STATE_NAMES.AUTHORITY_FULL_DISPLAY)
                && item.context !== 'WorldCat') {
            if (this.$state.params['search_scope']) {
                payload.search_scope = this.$state.params['search_scope'];
            }
            payload = this.addEntryIfDefined(payload,'tab',this.searchFieldsService.tab);
            if (this.$state.params['adaptor']) {
                payload.adaptor = this.$state.params['adaptor'];
            }
        } else if (item.context == 'v2v'){
        	payload.search_scope = this.searchStateService.getSearchObject().scope;
        	payload.tab = this.searchStateService.getSearchObject().tab;        	
        }
        if(this.journalsService.isJournalSearch() || this.databasesService.isDBSearch() || this.authoritySearchService.isAuthorityState()){
            payload = this.addEntryIfDefined(payload,'state',this.$state.current.name);
        }
        return payload;
    }

    public buildPayloadMultiItems(items): Object{
        if(!items){
            return {};
        }
        let payload: IPayLoadMulti = {
            'vid': this.vid,
            'lang': this.$translate.use(),
            'records': items.map((item) => {return {
                'docid': this.getRecordId(item.pnx.control),
                'adaptor': item.adaptor,
                'context': item.context,
                'pnx': item.pnx
            }})
        };
        return payload;
    }
    
    public getRecordId(itemControl) {
        let recordId = itemControl.recordid[0];
        if (recordId.startsWith('dedupmrg') || recordId.startsWith('TN_dedupmrg')) {
            let originalRecordId = itemControl.sourcerecordid[0];
            let index = originalRecordId.indexOf('$$O');
            if (index !== -1) {
                    originalRecordId = originalRecordId.substring(index+3);
            }
            return originalRecordId;         
        }
        return recordId;
        
        
    }
    
     public getNewspapersRecordId(itemControl) {
        let recordId = itemControl.addsrcrecordid[0];
        return 'BM_' + recordId;
    }
    
    public getPermalink(item, selectedIds){
        //let searchScope= this.searchStateService.getSearchObject().scope;
        let payload= this.buildPayload(item, selectedIds);
        return this.$http.post(this.PERMALINK_API_URL,payload);
    }

    public getPermalinksForExcel(items){
        let payload= this.buildPayloadMultiItems(items);
        return this.$http.post(this.PERMALINK_API_URL,payload);
    }
    
    private addEntryIfDefined(addTo, param, value){
        if (typeof value !== 'undefined') {
            addTo[param] = value;
        }
        return addTo;
    }

}

export default['nddUtils'];





// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/permalinkAction/permalink.service.ts